import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './blocks/home/home/home.component';
import { AuthenticationGuard } from './core/guards/auth.guards';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found/page-not-found.component';
import { RoutePermissionGuard } from './core/guards/route-permission.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full',
  },

  {
    path: 'home',
    component: HomeComponent,
  },
  {
    path: 'authentication',
    loadChildren: () =>
      import('./features/authentication/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'dashboard',
    canActivate: [AuthenticationGuard],
    loadChildren: () =>
      import('./features/dashboard/dashboard.module').then(
        (m) => m.DashboardModule
      ),
  },

  // {
  //   path: 'authentication',
  //   loadChildren: () =>
  //     import('./features/identity/authentication/authentication.module').then(
  //       (m) => m.AuthenticationModule
  //     ),
  // },

  // {
  //   path: 'adminstration',
  //   canActivate: [AuthenticationGuard],
  //   loadChildren: () =>
  //     import('./features/adminstration/adminstration.module').then(
  //       (m) => m.AdminstrationModule
  //     ),
  // },
  // {
  //   path: 'survey',
  //   canActivate: [AuthenticationGuard],
  //   loadChildren: () =>
  //     import('./features/survey/survey.module').then((m) => m.SurveyModule),
  // },

  // {
  //   path: 'KYC',
  //   canActivate: [AuthenticationGuard],
  //   loadChildren: () =>
  //     import('./features/kyc/kyc.module').then((m) => m.KYCModule),
  // },

  // {
  //   path: 'identity/investors',
  //   canActivate: [AuthenticationGuard],
  //   loadChildren: () =>
  //     import('./features/identity/investors/investors.module').then(
  //       (m) => m.InvestorsModule
  //     ),
  // },
  // {
  //   path: 'user-invitation',
  //   canActivate: [AuthenticationGuard],
  //   loadChildren: () =>
  //     import('./features/identity/user-invitation/user-invitation.module').then(
  //       (m) => m.UserInvitationModule
  //     ),
  // },
  // {
  //   path: 'identity/investorsWating',
  //   canActivate: [AuthenticationGuard],
  //   loadChildren: () =>
  //     import(
  //       './features/identity/investor-waiting/investor-waiting.module'
  //     ).then((m) => m.InvestorWaitingModule),
  // },
  // {
  //   path: 'identity/ContactUs',
  //   canActivate: [AuthenticationGuard],
  //   loadChildren: () =>
  //     import('./features/identity/contact-us/contact-us.module').then(
  //       (m) => m.ContactUsModule
  //     ),
  // },

  // {
  //   path: 'userAdmin',
  //   canActivate: [AuthenticationGuard],
  //   loadChildren: () =>
  //     import('./features/identity/user-admin/user-admin.module').then(
  //       (m) => m.UserAdminModule
  //     ),
  // },
  // {
  //   path: 'Funds',
  //   canActivate: [AuthenticationGuard],
  //   loadChildren: () =>
  //     import('./features/funds/funds.module').then((m) => m.FundsModule),
  // },
  // {
  //   path: 'Funds/attachmentTypes',
  //   canActivate: [AuthenticationGuard],
  //   loadChildren: () =>
  //     import('./features/funds/funds.module').then((m) => m.FundsModule),
  // },
  // {
  //   path: 'faq',
  //   canActivate: [AuthenticationGuard],
  //   loadChildren: () =>
  //     import('./features/faq/system-faq/system-faq.module').then(
  //       (m) => m.SystemFaqModule
  //     ),
  // },
  // {
  //   path: 'system-info',
  //   canActivate: [AuthenticationGuard],
  //   loadChildren: () =>
  //     import('./features/faq/system-info/system-info.module').then(
  //       (m) => m.SystemInfoModule
  //     ),
  // },
  // {
  //   path: 'interest-conflict',
  //   canActivate: [AuthenticationGuard],
  //   loadChildren: () =>
  //     import('./features/faq/interest-conflict/interest-conflict.module').then(
  //       (m) => m.InterestConflictModule
  //     ),
  // },
  // {
  //   path: 'wallet',
  //   canActivate: [AuthenticationGuard],
  //   loadChildren: () =>
  //     import(
  //       './features/wallet/wallet-transaction/wallet-transaction.module'
  //     ).then((m) => m.WalletTransactionModule),
  // },
  // {
  //   path: 'upgradeProfile',
  //   canActivate: [AuthenticationGuard],
  //   loadChildren: () =>
  //     import(
  //       './features/profile-upgrade/profile-upgrade/profile-upgrade.module'
  //     ).then((m) => m.ProfileUpgradeModule),
  // },
  // {
  //   path: 'payment',
  //   canActivate: [AuthenticationGuard],
  //   loadChildren: () =>
  //     import('./features/payments/payments.module').then(
  //       (m) => m.PaymentsModule
  //     ),
  // },
  // {
  //   path: 'notification',
  //   canActivate: [AuthenticationGuard],
  //   loadChildren: () =>
  //     import('./features/Notification/notification.module').then(
  //       (m) => m.SendNotificationModule
  //     ),
  // },
  // {
  //   path: 'mozn',
  //   canActivate: [AuthenticationGuard],
  //   loadChildren: () =>
  //     import('./features/identity/mozn/mozn.module').then((m) => m.MoznModule),
  // },
  // {
  //   path: 'iqama-histories',
  //   canActivate: [AuthenticationGuard],
  //   loadChildren: () =>
  //     import('./features/identity/iqama-histories/iqama-histories.module').then(
  //       (m) => m.IqamaHistoriesModule
  //     ),
  // },
  // {
  //   path: 'workflow',
  //   canActivate: [AuthenticationGuard],
  //   loadChildren: () =>
  //     import('./features/workflow/workflow.module').then(
  //       (m) => m.WorkflowModule
  //     ),
  // },
  // {
  //   path: 'dashboard-summary',
  //   canActivate: [AuthenticationGuard],
  //   loadChildren: () =>
  //     import('./features/dashboard-summary/dashboard-summary.module').then(
  //       (m) => m.DashboardSummaryModule
  //     ),
  // },
  // {
  //   path: 'fund-manager',
  //   canActivate: [AuthenticationGuard],
  //   loadChildren: () =>
  //     import('./features/fund-manager/fund-manager.module').then(
  //       (m) => m.FundManagerModule
  //     ),
  // },
  // {
  //   path: 'investor-portal',
  //   canActivate: [AuthenticationGuard],
  //   loadChildren: () =>
  //     import('./features/investor-portal/investor-portal.module').then(
  //       (m) => m.InvestorPortalModule
  //     ),
  // },
  // {
  //   path: 'reports',
  //   canActivate: [AuthenticationGuard],
  //   loadChildren: () =>
  //     import('./features/user-reports/user-reports.module').then((m) => m.UserReportsModule),
  // },
  // {
  //   path: 'set-fund-manager-password/:email',
  //   component: FundManagerSetPasswordComponent,
  // },

  {
    path: '**',
    component: PageNotFoundComponent,
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
